import { Translate } from '@chipinside/translate'
import { Box, IconButton, Modal, Paper } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useEffect } from 'react'

import { Icon } from '#/components/Icon'
import Loader from '#/components/Loader'
import { useFarmName } from '#/store/ducks/farm'
import { download, getFileBlob } from '#/utils/download'
import { getFormattedBreadcrumbPath } from '#/utils/getFormattedBreadcrumbPath'

const ModalHeader = styled(Box)({
  position: 'absolute',
  right: '10px',
  top: '10px',
})

const ModalContent = styled(Paper)({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  left: '50%',
  padding: '50px 32px',
  position: 'absolute',
  textAlign: 'center',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
})

const ExportFile = props => {
  const { controller, exportType, modalOpen, onCloseModal = () => {}, params } = props
  const farmName = useFarmName()

  useEffect(() => {
    if (modalOpen) {
      const fileName = getFormattedBreadcrumbPath(farmName)

      getFileBlob({
        params: { ...params, format: exportType },
        url: controller,
      })
        .then(fileURL => download({ fileName, fileURL }))
        .finally(() => onCloseModal())
    }
  }, [modalOpen])

  return (
    <Modal open={modalOpen} onClose={onCloseModal}>
      <ModalContent style={{ borderRadius: 16 }}>
        <ModalHeader>
          <IconButton aria-label="Close" onClick={onCloseModal}>
            <Icon size="large" name="mui-close" />
          </IconButton>
        </ModalHeader>
        <div>{Translate({ messageKey: 'exporting' })}</div>
        <Loader status="started" />
      </ModalContent>
    </Modal>
  )
}

export default ExportFile
